import { render, staticRenderFns } from "./gl_modal.vue?vue&type=template&id=35fa04ac"
import script from "./gl_modal.vue?vue&type=script&lang=js"
export * from "./gl_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports